import { Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'
import DoubleCurrencyLogo from 'components/Logo/DoubleLogo'

export const FeaturedCard = styled(Flex)`
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border: 1px solid;
  border-color: ${({ theme }) => theme.colors.text};
  margin-left: 10px;
  margin-right: 10px;
  background: transparent;
  width: 290px;
  height: 320px;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 1rem;
  border-radius: 24px;
  box-shadow: 0 10px 24px -10px #ff9a00, 0 -20px 24px -30px #ffe808, 0 0 4px #fff, 0 0 8px #ff0000;
`

export const HotText = styled.span`
  background: linear-gradient(to right, #ff0000, #ff5a00, #ff9a00, #ffce00, #ffe808);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  font-size: 32px;
`

export const HomeDouble = styled(DoubleCurrencyLogo)`
  width: 24px;
  height: 24px;
  @media (min-width: 1000px) {
    width: 80px;
    height: 80px;
  }
`
